<template>
  <div id="app">
    <v-app>
      <v-card>
        <v-card-title>パスワードを再設定する</v-card-title>
        <v-card-subtitle
          >パスワードを忘れた方は、こちらからパスワードを再設定してください。<br />
          <br />
          パスワードを覚えている方は<a @click="toSignIn">こちら</a>。<br />
          アカウントをお持ちでない方は<a @click="toSignUp">こちら</a>。
        </v-card-subtitle>
        <v-card-text>
          <v-text-field v-model="email" label="メールアドレス"> </v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="passwordReset"
            >パスワードの再設定メールを送信</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-app>
  </div>
</template>
<script>
import { firebaseService } from "@/services/firebase"
export default {
  data() {
    return {
      email: "",
      err: null,
    }
  },
  methods: {
    toSignIn() {
      this.$router.push("signin")
    },
    toSignUp() {
      this.$router.push("signup")
    },
    async passwordReset() {
      await firebaseService
        .sendPasswordResetEmail(this.email)
        .catch((error) => {
          this.err = error
        })
      alert("パスワード再設定のメール送りました🔥🚀")
      location.reload()
    },
  },
}
</script>
<style lang="scss" scoped></style>
